import { ServiceAccountSection } from '@/components/ServiceAccount/ServiceAccountSection';
import { UsersTable } from '@/components/Users/UsersTable';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { usePageTitle } from '@/hooks/usePageTitle';
import { createUseStyles } from '@/services/createUseStyles';
import { Box, Divider } from '@mui/material';

const contentMaxWidth = '750px';

const useStyles = createUseStyles({
  Users_root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    gap: '16px',
    overflowY: 'auto',
    padding: '24px',
  },
  Users_header: {
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  Users_content: {
    flexGrow: 1,
    overflowY: 'auto',
  },
});

export const UsersPage = () => {
  const c = useStyles();
  const { permissions } = useGetCurrentUser();

  usePageTitle('Users');

  return (
    <Box className={c.Users_root}>
      <Box sx={{ width: '100%', maxWidth: contentMaxWidth, mb: 2 }}>
        <ServiceAccountSection />
      </Box>

      {permissions.canManageUsers && <Divider sx={{ width: '100%', maxWidth: contentMaxWidth, mb: 2 }} />}

      {permissions.canManageUsers && (
        <Box sx={{ width: '100%', maxWidth: contentMaxWidth }}>
          <UsersTable />
        </Box>
      )}
    </Box>
  );
};
